import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/customer`,{params:searchParams});
    }

    get(id){
      return this.http.get(`${environment.baseUrl}/customer/`+id);
    }

    edit(id,formData){
      return this.http.put(`${environment.baseUrl}/customer/`+id,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/customer`,formData);
    }

    delete(id){
      return this.http.delete(`${environment.baseUrl}/customer/`+id);
    }

    reference(reference){
      return this.http.get(`${environment.baseUrl}/customer/reference/`+reference);
    }

}
